import { useEffect } from "react";
import { formatDocumentTitle } from "@/lib/documentTitle";

/** Sets `document.title` to `Page | Habits365Greek` while mounted. */
export function useDocumentTitle(page?: string | null): void {
  useEffect(() => {
    document.title = formatDocumentTitle(page);
  }, [page]);
}
